// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller";
import Hunt from "huntjs";
import { Application } from "@splinetool/runtime";
export default class SplineSceneController extends AdvancedController {
  static targets = ["canvas"];

  static values = { animationPath: String };

  connect() {
    super.connect(...arguments);
    this.inViewPort = false;
    this.app = new Application(this.canvasTarget, { renderMode: "auto" });
    this.animationLoaded = false;
    new Hunt(this.element, {
      persist: true,
      offset: window.innerHeight * 0.5,
      enter: () => this.playAnimation(),
      leave: () => this.stopAnimation(),
    });
    // this.loadAnimation();
  }

  async loadAnimation() {
    await this.app.load(this.animationPathValue);

    if (!this.inViewPort) {
      this.app.stop();
    }
  }
  async playAnimation() {
    this.inViewPort = true;

    if (this.animationLoaded === false) {
      await this.loadAnimation();
    }

    if (this.app) {
      this.app.play();
    }
  }

  stopAnimation() {
    this.inViewPort = false;
    if (this.app) {
      this.app.stop();
      this.app.dispose();
    }
  }
}
